



















import { State, Getter, Action } from 'vuex-class';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { SortOrder } from '@/enums/SortOrder';
import { Searchable } from '@/mixins/searchable';

@Component({
  components: {
    PagePresetDashboard: () => import('@/layouts/presets/dashboard.vue'),
    TableBase: () => import('@/components/table/base.vue'),
  },
})
export default class PageResellers extends Searchable<Reseller> {
  @Getter('reseller/all') resellers!: Reseller[];

  @Action('reseller/index') indexResellers!: (payload: { query?: IndexQuery<Reseller> }) => Promise<Reseller[]>;

  i18n: string = 'views.resellers.index';

  searchItemsProperty = 'resellers';

  localResellers: Reseller[] = [];

  tableLayout = {
    settings: {
      locale_path: `${this.i18n}.table`,
      max_height: 'calc(100% - 80px)',
      clickable: true,
    },
    structure: [
      {
        key: 'id',
        value: (model: Reseller) => `#${model.id}`,
        width: 75,
      },
      {
        key: 'name',
      },
      {
        key: 'min_order_amount',
        value: (model: Reseller) => `€${model.min_order_amount}`,
      },
      {
        key: 'discount_percentage',
        value: (model: Reseller) => `${Math.round(model.discount_percentage * 100)}%`,
      },
    ],
  };

  handleSort(item: any) {
    this.sorting = item;
    this.indexResellers({ query: { per_page: 20, s: this.sortQuery } });
  }

  loadMore() {
    this.indexResellers({ query: { per_page: 20, after: this.lastAfter, s: this.sortQuery } });
  }

  @Watch('resellers', { immediate: true })
  resellersChanged(val: Reseller[]) {
    this.localResellers = val;
  }
}
